<template>
    <v-checkbox
        v-bind="$attrs"
        v-on="$listeners"
        v-model="val"
        @change="on_change"
        :color="$attrs.color || 'primary'"
        class="custom-checkbox"
        hide-details="auto"
    >
        <!-- Pass on all named slots -->
        <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
        <!-- Pass on all scoped slots -->
        <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
            <slot :name="slot" v-bind="scope" />
        </template>
    </v-checkbox>
</template>
<script>
import EventBus from '../../../libs/EventBus';

export default {
    props: ['value'],
    data() {
        return {
            val: this.$props.value,
        };
    },
    methods: {
        on_change(e) {
            EventBus.$emit('form_input_changed');
            this.$emit('input', e);
            this.$emit('change', e);
        },
    }
};
</script>
